var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"loading":_vm.loading,"headers":_vm.headers,"items":_vm.items,"disable-pagination":"","hide-default-footer":"","no-data-text":_vm.$t('evaluations.components.score-table.no_data'),"multi-sort":"","dense":""},scopedSlots:_vm._u([{key:"item.action",fn:function(ref){
var item = ref.item;
return [_c('v-checkbox',{on:{"click":function($event){return _vm.$emit('showRadar', item)}}})]}},{key:"item.name",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.firstName)+" "+_vm._s(item.lastName)+" ")]}},{key:"item.email",fn:function(ref){
var item = ref.item;
return [_c('email-display',{attrs:{"email":item.email}})]}},{key:"item.target",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.target)+" ")]}},{key:"item.total",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("num")(item.total,2))+" ")]}},{key:"item.netTotal",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("num")(item.netTotal,2))+" ")]}},{key:"item.bonus",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("num")(item.bonus,2))+" ")]}},{key:"item.discrepancy",fn:function(ref){
var item = ref.item;
return [_c('score-display',{attrs:{"value":item.discrepancy,"is-positive":item.discrepancy >= 0,"is-negative":item.discrepancy < 0,"fractional-digits":2}})]}},{key:"item.detail",fn:function(ref){
var item = ref.item;
return [_c('v-btn',{attrs:{"icon":"","title":_vm.$t('evaluations.components.score-table.commands.details')},on:{"click":function($event){return _vm.$emit('details', item)}}},[_c('v-icon',[_vm._v("search")])],1)]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }